import { createTheme as createMuiTheme, Theme } from "@mui/material/styles";
import * as React from "react";
import { DialogsProvider } from "../useDialogs";
import { IframeProvider } from "../useIframe/useIframe";
import { NavigationProvider } from "../useNavigation/useNavigation";
import { NotificationsProvider } from "../useNotifications";
import { SessionProvider } from "../useSession/useSession";
import { AppThemeProvider } from "./AppThemeProvider";

export interface AppProviderProps {
  /**
   * The content of the app provider.
   */
  children: React.ReactNode;
  /**
   * A [CSS variables theme](https://mui.com/material-ui/customization/css-theme-variables/overview/) is recommended.
   * @default createTheme()
   */
  theme?: Theme;
}

function createTheme(): Theme {
  return createMuiTheme({
    cssVariables: {
      colorSchemeSelector: "data-toolpad-color-scheme",
    },
    colorSchemes: { dark: true },
  });
}

function AppProvider(props: AppProviderProps) {
  const { children, theme = createTheme() } = props;

  return (
    <AppThemeProvider theme={theme}>
      <IframeProvider>
        <NotificationsProvider>
          <DialogsProvider>
            <SessionProvider>
              <NavigationProvider>{children}</NavigationProvider>
            </SessionProvider>
          </DialogsProvider>
        </NotificationsProvider>
      </IframeProvider>
    </AppThemeProvider>
  );
}

export { AppProvider };
